<template>
  <div class="container">
      <div class="page">
            
          <div class="notfound">
              <div class="notfound-image"></div>
              <div class="notfound-text">小优迷路了～</div>
          </div>
          
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
  
  }
}
</script>
<style scoped>
 .container, .page {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.container {
    overflow:hidden;
}
.page {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 1;
}
.notfound {
    width: 80%;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.notfound-image {
    width: 230px;
    height: 285px;
    background-image: url("../assets/404.svg"); /*这里自己加图片url*/
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
}
.notfound-text {
    margin-top: 20px;
    font-size: 14px;
    color: #333;
  text-align: center;

}
</style>



// WEBPACK FOOTER //
// src/components/NotFount.vue